import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, HostListener, ViewChild, OnDestroy, ViewChildren, QueryList, ElementRef } from '@angular/core';
import { NgbDropdown, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Editor, Toolbar } from 'ngx-editor';
import { Task, Subtask, Milestone, Project, Employee, UiSubtask, TaskAttachment } from 'src/app/core/models/project-pilot.model';
import { ConfirmationPopupComponent } from 'src/app/shared/component/confirmation-popup/confirmation-popup.component';
import { Context } from 'src/app/shared/models/context';
import { Message, TableData } from 'src/app/shared/models/domain';
import { AuthService } from 'src/app/shared/services/auth.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { DomainService } from 'src/app/shared/services/domain.service';
import { ProjectPilotService } from 'src/app/shared/services/project-pilot.service';
import { DatePipe, formatDate } from '@angular/common';
import { Subscription } from 'rxjs';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { sequence } from '@angular/animations';

@Component({
  selector: 'app-tasks',
  templateUrl: './tasks.component.html',
  styleUrls: ['./tasks.component.scss']
})
export class TasksComponent implements OnInit, OnDestroy {
  @ViewChildren('taskTitle') taskTitles!: QueryList<ElementRef<HTMLTextAreaElement>>;
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
  public task!: FormGroup;
  public milestones: Milestone[] = [];
  public searchKeyword: string = "";
  public statuses: string[] = [];
  public priorities: string[] = [];
  public searchIndex: number = 0;
  private subscription!: Subscription;
  private employees: Employee[] = [];


  @ViewChild('dropdown') dropdown: NgbDropdown;
  public selectedTasks: number[] = [];
  public showSidePopup: boolean = false;
  public newTask!: Task | UiSubtask;
  public isSubItem: boolean = false;
  public parentTaskId: number | null = null;
  public showDatePicker: boolean = false;
  public isDeleteInProgress = false;
  public activeTab: string = 'tasks';
  public filteredTasks: Task[] = [];
  public sortDirection: 'asc' | 'desc' | null = null;
  public subtasks: UiSubtask[] = [];
  public projects: Project[] = [];
  public filteredProjects: Project[] = [];
  public filteredMilestones: Milestone[] = [];
  public taskss: Task[] = [];
  public selectedFilter: string = '';
  public filters: string[] = [];
  public fromDate: Date;
  public toDate: Date;
  public filter: any;
  public isLoading: boolean = true;
  public tableData: TableData = { content: [] } as TableData;
  public pageSizes: number[] = [];
  private pageDataKey: string = 't';
  public projectId: number | null = null;
  public selectedStatus: string = 'NOT_STARTED';
  public selectedPriority: string = 'MEDIUM';
  public context: Context;
  public editor: Editor;
  public toolbar: Toolbar = [
    ['bold', 'italic'],
    ['underline', 'strike'],
    ['code', 'blockquote'],
    ['ordered_list', 'bullet_list'],
    [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
    ['link', 'image'],
    ['text_color', 'background_color'],
    ['align_left', 'align_center', 'align_right', 'align_justify'],
  ];

  constructor(
    private fb: FormBuilder,
    private projectPilotService: ProjectPilotService,
    private datePipe: DatePipe,
    private authService: AuthService,
    private commonService: CommonService,
    private modalService: NgbModal,
    private domainService: DomainService
  ) { }

  ngOnInit(): void {
    this.initTaskForm();
    this.subscription = this.authService.getContext().subscribe(context => {
      if (context?.projectId) {
        this.context = context;
        this.getTasks();
      }
    });
    this.getMilestones();
    this.getEmployees();
    this.getTaskPriorities();
    this.getTaskStatuses();


    this.getStatuses();
    this.priorities = this.commonService.getPriorities();
    this.projectPilotService.fetchProjects(false).subscribe((projects: Project[]) => {
      this.projects = projects;
      if (this.projects.length > 0) {
        const selectedProject = this.projects[0];
        this.projectId = selectedProject.id;
      }
    });

    this.editor = new Editor();
    this.taskss = [this.createEmptyTask()];
    this.filteredTasks = [...this.taskss];
    this.newTask = this.createEmptyTask();
    // this.fetchEmployees();
    // this.fetchMilestones();
    this.fetchProjects();
    this.filters = this.domainService.getDateFiltersTypes();
    this.selectedFilter = this.filters[2];
    this.filter = {
      from: "",
      to: "",
    }
    // this.getTasks();
  }

  private initTaskForm() {
    this.task = this.fb.group({ tasks: this.fb.array([]) });
  }

  private getTasks() {
    this.projectPilotService.getTasks(this.context.projectId).subscribe({
      next: (tasks: Task[]) => {
        tasks.sort((a, b) => a.sequence - b.sequence).forEach(task => this.tasks.push(this.setTask(task)));
        setTimeout(() => {
          this.taskTitles.forEach((title) => {
            this.resizeTextArea(title.nativeElement);
          });
        });
      },
      error: (err) => console.error('Error fetching employees:', err)
    });
  }

  private getTaskPriorities() {
    this.projectPilotService.getTaskPriorities().subscribe({
      next: (priorities: string[]) => {
        this.priorities = priorities;
      },
    });
  }

  private getTaskStatuses() {
    this.projectPilotService.getTaskStatuses().subscribe({
      next: (statuses: string[]) => {
        this.statuses = statuses;
      },
    });
  }

  private setTask(task?: Task) {
    if (!task) task = {
      id: null,
      title: '',
      sequence: this.tasks.value.length + 1,
      desc: '',
      status: 'NOT_STARTED',
      priority: 'LOW',
      deadLine: '',
      estimatedHours: null,
      actualHours: null,
      estimatedTime: '',
      completedTime: '',
      performance: null,
      disabled: false,
      projectId: this.context.projectId,
      projectName: '',
      milestoneId: null,
      milestoneName: '',
      ownerId: this.authService.getUserId(),
      ownerName: '',
      assignedToId: null,
      assignedToName: '',
      selected: false,
      editTask: false,
      isExpanded: false,
      isEditing: false,
      showStatusDropdown: false,
      showAssigneeDropdown: false,
      showPriorityDropdown: false,
      showProjectDropdown: false,
      showMilestoneDropdown: false
    } as Task;
    return this.fb.group({
      id: this.fb.control(task.id, []),
      title: this.fb.control(task.title, [Validators.required]),
      sequence: this.fb.control(task.sequence, []),
      desc: this.fb.control(task.desc, []),
      status: this.fb.control(task.status, []),
      priority: this.fb.control(task.priority, []),
      deadLine: this.fb.control(task?.deadLine ? this.datePipe.transform(task.deadLine, 'yyyy-MM-dd') : '', []),
      estimatedHours: this.fb.control(task.estimatedHours, []),
      actualHours: this.fb.control(task.actualHours, []),
      estimatedTime: this.fb.control(task.estimatedTime, []),
      completedTime: this.fb.control(task.completedTime, []),
      performance: this.fb.control(task.performance, []),
      disabled: this.fb.control(task.disabled, []),
      projectId: this.fb.control(task.projectId, []),
      projectName: this.fb.control(task.projectName, []),
      milestoneId: this.fb.control(task.milestoneId, []),
      milestoneName: this.fb.control(task.milestoneName, []),
      ownerId: this.fb.control(task.ownerId, [Validators.required]),
      ownerName: this.fb.control(task.ownerName, []),
      assignedToId: this.fb.control(task.assignedToId, []),
      assignedToName: this.fb.control(task.assignedToName, []),
      selected: this.fb.control(false, []),
      editTask: this.fb.control(false, []),
      isExpanded: this.fb.control(task.isExpanded, []),
      isEditing: this.fb.control(task.isEditing, []),
      showStatusDropdown: this.fb.control(task.showStatusDropdown, []),
      showAssigneeDropdown: this.fb.control(task.showAssigneeDropdown, []),
      showPriorityDropdown: this.fb.control(task.showPriorityDropdown, []),
      showProjectDropdown: this.fb.control(task.showProjectDropdown, []),
      showMilestoneDropdown: this.fb.control(task.showMilestoneDropdown, []),
      taskAttachments: this.fb.array(task?.taskAttachments?.map(attachment => this.setTaskAttachment(attachment)) || []),
    });
  }

  private setTaskAttachment(attachment?: TaskAttachment) {
    if (!attachment) attachment = {
      id: null,
      fileUrl: '',
      disabled: false,
      taskId: null,
      taskName: ''
    } as TaskAttachment;
    return this.fb.group({
      id: this.fb.control(attachment.id, []),
      fileUrl: this.fb.control(attachment.fileUrl, []),
      disabled: this.fb.control(attachment.disabled, []),
      taskId: this.fb.control(attachment.taskId, []),
      taskName: this.fb.control(attachment.taskName, [])
    });
  }

  public openFilePicker(task: Task, element: HTMLInputElement): void {
    if (!task?.id) return;
    element.click();
  }

  public onFileSelected(event: Event, task: Task, index: number): void {
    console.log(index);
    console.log(task)
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      const maxSizeInMB = 20;
      const maxSizeInBytes = maxSizeInMB * 1024 * 1024;
      if (file.size > maxSizeInBytes) {
        this.commonService.setToastr(500, `File size exceeds ${maxSizeInMB}MB limit.`);
        console.warn(`File size exceeds ${maxSizeInMB}MB limit.`);
        return;
      }
      this.upsertAttachment(file, task, index);
    }
  }

  get tasks() {
    return this.task.get('tasks') as FormArray;
  }

  public taskAttachments(i: number) {
    return this.tasks.at(i).get('taskAttachments') as FormArray;
  }

  get isAllTasksSelected() {
    return this.tasks.controls.some((task: FormGroup) => task.get('selected')?.value);
  }

  public upsertTask(taskForm: FormGroup): void {
    if (taskForm.valid) {
      const taskData = taskForm.value;
      if (taskData.id) {
        this.projectPilotService.updateTask(taskData.id, taskData).subscribe({
          next: (response: Message) => {
            if (!response.failed) {
              this.getAndPatchTask(parseInt(response.payload), taskForm);
            }
          },
          error: (err) => console.error('Error updating task:', err)
        });
      } else {
        this.projectPilotService.createTask(taskData).subscribe({
          next: (response: Message) => {
            if (!response.failed) {
              this.getAndPatchTask(parseInt(response.payload), taskForm);
            }
          },
          error: (err) => console.error('Error creating task:', err)
        });
      }
    }
  }

  public upsertAttachment(file: File, task: Task, index: number): void {
    if (file?.size > 0 && task?.id) {
      const attachment: TaskAttachment = { id: null, fileUrl: '', disabled: false, taskId: task.id, taskName: task.title };
      this.projectPilotService.createTaskAttachment(attachment).subscribe({
        next: (response: Message) => {
          if (!response.failed) {
            const attachmentId = parseInt(response.payload);
            this.uploadTaskAttachment(attachmentId, file, index);
          }
        },
        error: (err) => console.error('Error creating task attachment:', err)
      });
    }
  }

  private getAndPatchAttachment(attachmentId: number, index: number): void {
    this.projectPilotService.getTaskAttachment(attachmentId).subscribe({
      next: (attachment: TaskAttachment) => {
        if (!attachment || !attachment.id) return;
        console.log(index)
        console.log(this.tasks.at(index).value);
        console.log(this.tasks.at(index).get('taskAttachments')?.value);
        this.taskAttachments(index).push(this.setTaskAttachment(attachment));
      },
    });
  }

  private uploadTaskAttachment(attachmentId: number, file: File, index: number): void {
    if (!attachmentId) return;
    const formData = new FormData();
    formData.append('file', file);
    this.projectPilotService.uploadTaskAttachment(attachmentId, formData).subscribe({
      next: (response: Message) => {
        if (!response.failed) {
          this.getAndPatchAttachment(attachmentId, index);
        }
      },
      error: (err) => console.error('Error uploading file:', err)
    });
  }

  public getFilePreviewIcon(url: string): string {
    return this.commonService.getFilePreviewIcon(url);
  }

  private getMilestones(): void {
    this.projectPilotService.getMilestones().subscribe({
      next: (milestones: Milestone[]) => {
        this.milestones = milestones;
      },
    });
  }

  private getEmployees(): void {
    this.projectPilotService.getEmployees().subscribe({
      next: (employees: Employee[]) => {
        this.employees = employees;
      },
    });
  }

  public toggleAssigneeDropdown(task: Task): void {
    this.resetDropdownToggleStatus();
    task.showAssigneeDropdown = !task.showAssigneeDropdown;
  }

  public toggleMilestoneDropdown(task: Task): void {
    this.resetDropdownToggleStatus();
    task.showMilestoneDropdown = !task.showMilestoneDropdown;
  }

  public toggleDueDate(task: Task, dueDateRef: any): void {
    this.resetDropdownToggleStatus();
    task.showDueDate = !task.showDueDate;
    console.log(task.deadLine)
    setTimeout(() => {
      dueDateRef.showPicker?.();
      dueDateRef.focus()
    }, 0);
  }

  public togglePriorityDropdown(task: Task): void {
    this.resetDropdownToggleStatus();
    task.showPriorityDropdown = !task.showPriorityDropdown;
  }

  public toggleStatusDropdown(task: Task): void {
    this.resetDropdownToggleStatus();
    task.showStatusDropdown = !task.showStatusDropdown;
  }

  private resetDropdownToggleStatus() {
    this.tasks.value.forEach(task => {
      task.showStatusDropdown = false;
      task.showAssigneeDropdown = false;
      task.showPriorityDropdown = false;
      task.showMilestoneDropdown = false;
      task.showDueDate = false;
    });
  }

  public setAssignee(taskForm: FormGroup, employee: Employee): void {
    taskForm.get('assignedToId')?.setValue(employee?.employeeId);
    taskForm.get('assignedToName')?.setValue(employee?.employeeName);
    taskForm.get('showAssigneeDropdown')?.setValue(false);
    this.upsertTask(taskForm);
    this.searchKeyword = "";
  }

  public setMilestone(taskForm: FormGroup, milestone: Milestone): void {
    taskForm.get('milestoneId')?.setValue(milestone?.id);
    taskForm.get('milestoneName')?.setValue(milestone?.title);
    taskForm.get('showMilestoneDropdown')?.setValue(false);
    this.upsertTask(taskForm);
    this.searchKeyword = "";
  }

  public setPriority(taskForm: FormGroup, priority: string): void {
    taskForm.get('priority')?.setValue(priority);
    this.upsertTask(taskForm);
  }

  public setStatus(taskForm: FormGroup, status: string): void {
    taskForm.get('status')?.setValue(status);
    this.projectPilotService.upsertTaskStatus(taskForm.value.id, status).subscribe({
      next: (response: Message) => {
        if (!response.failed) {
          this.getAndPatchTask(taskForm.value.id, taskForm);
        }
      },
      error: (err) => console.error('Error updating task status:', err)
    });
  }

  public resizeTextArea(textArea: HTMLTextAreaElement) {
    textArea.style.height = 'auto';
    textArea.style.height = textArea.scrollHeight + 'px';
  }

  private getAndPatchTask(taskId: number, taskForm: FormGroup,): void {
    const t: Task = taskForm.value;
    this.projectPilotService.getTask(taskId).subscribe({
      next: (task: Task) => {
        taskForm.patchValue({
          ...task,
          // showStatusDropdown: t.showStatusDropdown,
          // showMilestoneDropdown: t.showMilestoneDropdown,
          // showAssigneeDropdown: t.showAssigneeDropdown,
          // showPriorityDropdown: t.showPriorityDropdown,
          deadLine: task?.deadLine ? this.datePipe.transform(task.deadLine, 'yyyy-MM-dd') : '',
          editTask: false
        } as Task);
      },
    });
  }

  public handleKeyDown(event: KeyboardEvent, taskForm: FormGroup, type: string): void {
    const list: any =
      type === 'milestone' ? this.milestones.filter(m => m.title.toLowerCase().includes(this.searchKeyword?.toLowerCase() || '')) :
        type === 'assignee' ? this.employees.filter(e => e.employeeName.toLowerCase().includes(this.searchKeyword?.toLowerCase() || '')) :
          type === 'priority' ? this.priorities
            : [];
    if (event.key === 'ArrowDown') {
      this.searchIndex = (this.searchIndex + 1) % list.length;
      event.preventDefault();
    } else if (event.key === 'ArrowUp') {
      this.searchIndex = (this.searchIndex - 1 + list.length) % list.length;
      event.preventDefault();
    } else if (event.key === 'Enter') {
      console.log('s')
      const selected = list[this.searchIndex];
      if (selected) {
        if (type === 'assignee') {
          this.setAssignee(taskForm, selected);
        } else if (type === 'milestone') {
          this.setMilestone(taskForm, selected);
        } else if (type === 'priority') {
          // this.togglePriorityDropdown(taskForm.value);
          // this.setPriority(taskForm, selected);
        }

      }
    } else if (event.key === 'Tab') {
      taskForm.get('showAssigneeDropdown')?.setValue(false);
      taskForm.get('showMilestoneDropdown')?.setValue(false);
    }
  }

  public getTaskStatus(status: string): string {
    switch (status) {
      case 'NOT_STARTED':
        return 'Not Started';
      case 'IN_PROGRESS':
        return 'In Progress';
      case 'COMPLETED':
        return 'Completed';
      case 'HOLD':
        return 'On Hold';
      case 'REASSIGNED':
        return 'Reassigned';
      default:
        return status;
    }
  }






  private getStatuses(): void {
    this.statuses = ['NOT_STARTED', 'IN_PROGRESS', 'COMPLETED', 'ON_HOLD'].map(status =>
      status
        .toLowerCase()
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ')
    );
  }


  // private getMilestones(clear: boolean = true) {
  //   if (clear) {
  //     this.isLoading = true;
  //     this.tableData.content = [];
  //   }
  // }

  public clearAssignee(task: any): void {
    task.assignedToName = null;
    task.showAssigneeDropdown = false;
  }

  public toggleProjectDropdown(task: Task): void {
    task.showProjectDropdown = !task.showProjectDropdown;
    if (task.showProjectDropdown) {
      this.filteredProjects = [...this.projects];
    }
  }

  public filterProjects(task: Task, event: any): void {
    const searchText = event.target.value.toLowerCase();
    this.filteredProjects = this.projects.filter(project =>
      project.name.toLowerCase().includes(searchText)
    );
  }

  public selectProject(task: Task, project: Project): void {
    task.projectId = project.id;
    task.projectName = project.name;
    task.showProjectDropdown = false;
  }

  public clearProject(task: Task): void {
    task.projectId = null;
    task.projectName = '';
    task.showProjectDropdown = false;
  }

  public filterMilestones(task: Task, event: any): void {
    const searchText = event.target.value.toLowerCase();
    this.filteredMilestones = this.milestones.filter(milestone =>
      milestone.title.toLowerCase().includes(searchText)
    );
  }

  public selectMilestone(task: Task, milestone: Milestone): void {
    task.milestoneId = milestone.id;
    task.milestoneName = milestone.title;
    task.showMilestoneDropdown = false;
  }

  public clearMilestone(task: Task): void {
    task.milestoneId = null;
    task.milestoneName = '';
    task.showMilestoneDropdown = false;
  }

  // @HostListener('document:click', ['$event'])
  // public onDocumentClick(event: MouseEvent): void {
  //   const target = event.target as HTMLElement;
  //   if (!target.closest('.status-dropdown') &&
  //     !target.closest('.assignee-dropdown') &&
  //     !target.closest('.priority-dropdown') &&
  //     !target.closest('.milestone-dropdown') &&
  //     !target.closest('.date-column')) {
  //     this.taskss.forEach(task => {
  //       task.showStatusDropdown = false;
  //       task.showAssigneeDropdown = false;
  //       task.showPriorityDropdown = false;
  //       task.showMilestoneDropdown = false;
  //     });

  //     this.subtasks.forEach(subtask => {
  //       subtask.showStatusDropdown = false;
  //       subtask.showAssigneeDropdown = false;
  //       subtask.showPriorityDropdown = false;
  //       subtask.showMilestoneDropdown = false;
  //     });
  //     this.newTask.showStatusDropdown = false;
  //     this.newTask.showAssigneeDropdown = false;
  //     this.newTask.showPriorityDropdown = false;
  //     this.newTask.showMilestoneDropdown = false;
  //     this.showDatePicker = false;
  //   }
  // }

  public toggleSelectAll(): void {
    if (this.selectedTasks.length === this.taskss.length + this.subtasks.length) {
      this.selectedTasks = [];
    } else {
      this.selectedTasks = [
        ...this.taskss.filter(task => task.id !== undefined).map(task => task.id!),
        ...this.subtasks.filter(subtask => subtask.id !== undefined).map(subtask => subtask.id!)
      ];
    }
  }

  public toggleTaskSelection(id?: number): void {
    if (id === undefined) return;
    const index = this.selectedTasks.indexOf(id);
    if (index !== -1) {
      this.selectedTasks.splice(index, 1);
    } else {
      this.selectedTasks.push(id);
    }
  }

  public editTaskName(task: Task): void {
    task.isEditing = true;
  }






  public editSubTaskName(subTask: UiSubtask): void {
    subTask.isEditing = true;
  }

  public saveSubTaskName(subTask: UiSubtask): void {
    if (!subTask.title?.trim()) {
      alert('Subtask title cannot be empty.');
      subTask.title = '';
      subTask.isEditing = false;
      return;
    }
    if (subTask.id) {
      this.projectPilotService.updateSubtask(subTask.id, subTask).subscribe({
        next: (response: Message) => {
          alert(response.text);
          subTask.isEditing = false;
          this.applyFilters();
        },
        error: (err) => console.error('Error updating subtask:', err)
      });
    } else {
      this.projectPilotService.createSubtask(subTask).subscribe({
        next: (response: Message) => {
          subTask.id = response.payload ? parseInt(response.payload) : Math.max(...this.subtasks.map(s => s.id || 0), 0) + 1;
          alert(response.text);
          subTask.isEditing = false;
          this.applyFilters();
        },
        error: (err) => console.error('Error creating subtask:', err)
      });
    }
  }


  public selectStatus(item: Task | UiSubtask, status: string): void {
    item.status = status;
    item.showStatusDropdown = false;
    this.updateItem(item);
  }

  public toggleExpand(task: Task): void {
    task.isExpanded = !task.isExpanded;
  }

  public toggleDatePicker(): void {
    this.showDatePicker = !this.showDatePicker;
  }

  public addNewTask(): void {
    this.tasks.push(this.setTask());
  }

  public openSidePopup(isSubItem: boolean = false, parentId: number | null = null): void {
    this.isSubItem = isSubItem;
    this.parentTaskId = parentId;
    this.newTask = this.createEmptyTask();
    if (isSubItem && parentId) {
      (this.newTask as UiSubtask).taskId = parentId;
    }
    this.showSidePopup = true;
  }

  public closeSidePopup(): void {
    this.showSidePopup = false;
    this.newTask = this.createEmptyTask();
    this.isSubItem = false;
    this.parentTaskId = null;
  }

  public saveNewTask(): void {
    if (this.isSubItem && this.parentTaskId) {
      const newSubTask: UiSubtask = {
        ...this.newTask,
        taskId: this.parentTaskId,
        taskName: this.taskss.find(t => t.id === this.parentTaskId)?.title
      };
      this.projectPilotService.createSubtask(newSubTask).subscribe({
        next: (response: Message) => {
          newSubTask.id = response.payload ? parseInt(response.payload) : Math.max(...this.subtasks.map(s => s.id || 0), 0) + 1;
          this.subtasks.push(newSubTask);
          alert(response.text);
          this.closeSidePopup();
          this.applyFilters();
        },
        error: (err) => console.error('Error creating subtask:', err)
      });
    } else {
      const newTask: any = { ...this.newTask };
      this.projectPilotService.createTask(newTask).subscribe({
        next: (response: Message) => {
          newTask.id = response.payload ? parseInt(response.payload) : Math.max(...this.taskss.map(t => t.id || 0), 0) + 1;
          this.taskss.push(newTask);
          alert(response.text);
          this.closeSidePopup();
          this.applyFilters();
        },
        error: (err) => console.error('Error creating task:', err)
      });
    }
  }

  public setActiveTab(tab: string): void {
    this.activeTab = tab;
    this.applyFilters();
  }

  public sortTasks(direction: 'asc' | 'desc'): void {
    this.sortDirection = direction;
    this.applyFilters();
  }

  public trackByTaskId(index: number, task: Task): number {
    return task.id || index;
  }

  public trackBySubItemId(index: number, subTask: UiSubtask): number {
    return subTask.id || index;
  }
  // private getTasks(clear: boolean = true) {
  //   if (clear) {
  //     this.isLoading = true;
  //     this.tableData.content = [];
  //   }

  //   const pageSize = Number(this.tableData.size);
  //   const pageNumber = Math.max(1, Number(this.tableData.number) || 1);

  //   // this.projectPilotService.getTasks(
  //   //   pageNumber - 1,
  //   //   pageSize,
  //   //   false,
  //   //   this.projectId,
  //   //   this.selectedStatus,
  //   //   this.selectedPriority,
  //   //   this.fromDate ? formatDate(this.fromDate, 'dd-MM-yyyy', 'en') : undefined,
  //   //   this.toDate ? formatDate(this.toDate, 'dd-MM-yyyy', 'en') : undefined
  //   // ).subscribe({
  //   //   next: (tableData: TableData) => {
  //   //     this.tableData = tableData;
  //   //     this.tableData.size = pageSize;
  //   //     this.tableData.content = this.tableData?.content?.sort((a, b) => a.id - b.id);
  //   //     this.isLoading = false;
  //   //   },
  //   //   error: (error: HttpErrorResponse) => {
  //   //     this.isLoading = false;
  //   //     this.commonService.setToastr(500, error?.error?.name || error.error);
  //   //   }
  //   // });
  // }
  // private initializeTasks(): void {
  //   this.projectPilotService.getTasks(0, 100).subscribe({
  //     next: (response: TableData) => {
  //       this.taskss = response.content as Task[];
  //       this.taskss.forEach(task => {
  //         task.showStatusDropdown = false;
  //         task.showAssigneeDropdown = false;
  //         task.showPriorityDropdown = false;
  //         task.isExpanded = false;
  //         task.isEditing = false;
  //         this.fetchSubtasks(task.id!);
  //       });
  //       this.applyFilters();
  //     },
  //     error: (err) => console.error('Error fetching tasks:', err)
  //   });
  // }

  private fetchSubtasks(taskId: number): void {
    this.projectPilotService.getSubtasks(taskId, 0, 100).subscribe({
      next: (response: TableData) => {
        const fetchedSubtasks = (response.content as Subtask[]).map(subtask => ({
          ...subtask,
          showStatusDropdown: false,
          showAssigneeDropdown: false,
          showPriorityDropdown: false,
          isEditing: false
        })) as UiSubtask[];
        this.subtasks = [...this.subtasks.filter(st => st.taskId !== taskId), ...fetchedSubtasks];
        this.applyFilters();
      },
      error: (err) => console.error('Error fetching subtasks:', err)
    });
  }

  private fetchProjects(): void {
    this.projectPilotService.fetchProjects(false).subscribe({
      next: (projects: Project[]) => {
        this.projects = projects;
      },
      error: (err) => console.error('Error fetching projects:', err)
    });
  }

  private createEmptyTask(): Task | UiSubtask {
    return {
      id: null,
      title: '',
      desc: '',
      sequence: 0,
      status: 'NOT_STARTED',
      priority: 'LOW',
      deadLine: '',
      estimatedTime: '',
      completedTime: '',
      performance: 'BELOW_EXPECTATION',
      disabled: false,
      projectId: null,
      projectName: '',
      milestoneId: null,
      milestoneName: '',
      ownerId: this.context.employeeId,
      ownerName: '',
      assignedToId: null,
      assignedToName: '',
      isExpanded: false,
      isEditing: true,
      showStatusDropdown: false,
      showAssigneeDropdown: false,
      showPriorityDropdown: false
    };
  }

  private applyFilters(): void {
    this.filteredTasks = [...this.taskss];

    if (this.activeTab === 'assignee') {
      this.filteredTasks.sort((a, b) => {
        const assigneeA = a.assignedToName || '';
        const assigneeB = b.assignedToName || '';
        return assigneeA.localeCompare(assigneeB);
      });
    } else if (this.activeTab === 'priority') {
      this.filteredTasks.sort((a, b) => {
        const priorityOrder = { HIGH: 1, LOW: 2 };
        return (priorityOrder[a.priority || 'LOW'] - priorityOrder[b.priority || 'LOW']);
      });
    }

    // if (this.filters.assignee) {
    //   this.filteredTasks = this.filteredTasks.filter(task => task.assignedToName === this.filters.assignee);
    // }
    // if (this.filters.priority) {
    //   this.filteredTasks = this.filteredTasks.filter(task => task.priority === this.filters.priority);
    // }

    if (this.sortDirection) {
      this.filteredTasks.sort((a, b) => {
        if (this.sortDirection === 'asc') {
          return (a.id || 0) - (b.id || 0);
        } else {
          return (b.id || 0) - (a.id || 0);
        }
      });
    }
  }

  private updateItem(item: Task | UiSubtask): void {
    if ('taskId' in item && item.id) {
      this.projectPilotService.updateSubtask(item.id, item as Subtask).subscribe({
        next: (response: Message) => {
          alert(response.text);
          this.applyFilters();
        },
        error: (err) => console.error('Error updating subtask:', err)
      });
    } else if (item.id) {
      this.projectPilotService.updateTask(item.id, item as Task).subscribe({
        next: (response: Message) => {
          alert(response.text);
          this.applyFilters();
        },
        error: (err) => console.error('Error updating task:', err)
      });
    }
  }

  public deleteSelectedTasks(): void {
    if (this.selectedTasks.length === 0 || this.isDeleteInProgress) return;
    const modalRef = this.modalService.open(ConfirmationPopupComponent);
    modalRef.componentInstance.title = "Task Deletion";
    modalRef.componentInstance.message = `Delete ${this.selectedTasks.length} selected task(s)?`;
    modalRef.result.then((isConfirmed: boolean) => {
      if (isConfirmed) {
        this.isDeleteInProgress = true;
        this.projectPilotService.deleteTasks(this.selectedTasks).subscribe({
          next: (response: Message) => {
            this.isDeleteInProgress = false;
            if (!response.failed) {
              this.taskss = this.taskss.filter(task =>
                !this.selectedTasks.includes(task.id!)
              );
              this.subtasks = this.subtasks.filter(subtask =>
                !this.selectedTasks.includes(subtask.id!)
              );
              this.commonService.setToastr(200, response.message);
              this.selectedTasks = [];
            } else {
              this.commonService.setToastr(500, response.message);
            }
          },
          error: (error: HttpErrorResponse) => {
            this.isDeleteInProgress = false;
            this.commonService.setToastr(
              500,
              error.error?.message || error.message || 'Deletion failed'
            );
          }
        });
      }
    }).catch(() => { });
  }


  public filterAndFetchMilestone(filter: string, projectId: number | null, element?: any) {
    if (!projectId) {
      this.commonService.setToastr(400, 'Please select a project!');
      return;
    }

    const now = new Date();
    const today = new Date(now.setHours(0, 0, 0, 0)); // Set today to 12:00 AM
    let fromDate: Date;
    let toDate: Date;

    switch (filter) {
      case 'Today':
        fromDate = new Date(today);
        toDate = new Date(today);
        toDate.setHours(23, 59, 59, 999); // Set to 11:59:59 PM
        break;
      case 'Yesterday':
        fromDate = new Date(today);
        fromDate.setDate(today.getDate() - 1);
        fromDate.setHours(0, 0, 0, 0);
        toDate = new Date(today);
        toDate.setDate(today.getDate() - 1);
        toDate.setHours(23, 59, 59, 999);
        break;
      case 'Last Week':
        fromDate = new Date(today);
        fromDate.setDate(today.getDate() - 7);
        fromDate.setHours(0, 0, 0, 0);
        toDate = new Date(today);
        toDate.setHours(23, 59, 59, 999);
        break;
      case 'Custom':
        this.fromDate = this.formatDate(this.fromDate) as any;
        this.toDate = this.formatDate(this.toDate) as any;
        if (!this.fromDate || !this.toDate) {
          this.commonService.setToastr(400, 'Please select the date range!');
          return;
        }
        break;
      default:
        return;
    }
    element?.close();
    this.fromDate = this.formatDate(fromDate) as any;
    this.toDate = this.formatDate(toDate) as any;
    this.getTasks();
  }

  private formatDate(date: any): number {
    if (!date) return null;
    return new Date(date).getTime();
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}